import { effect, inject, Injectable } from '@angular/core';
import { WsMessageResponse } from 'app/shared/models/websocket/ws-message-response';
import { GlobalStore } from 'app/shared/store/global.store';
import { Subject } from 'rxjs';
import { StompService } from './stomp.service';

@Injectable({
  providedIn: 'root',
})
export class WebSocketService {
  private readonly globalStore = inject(GlobalStore);
  private readonly stompService = inject(StompService);

  public readonly message = new Subject<WsMessageResponse>();

  constructor() {
    effect(() => {
      if (this.globalStore.currentSession()) {
        this.handleMessageByUserId();
        this.handleMessageByUserName();
      }
    });
  }

  private handleMessage(message: any): void {
    const wsMessageResponse = JSON.parse(message) as WsMessageResponse;
    if (wsMessageResponse) {
      this.message.next(wsMessageResponse);
    }
  }

  private handleMessageByUserId() {
    this.connectToStomp(`/topic/user/${this.globalStore.currentSession().userId}`);
  }

  private handleMessageByUserName() {
    this.connectToStomp(`/topic/user-combined/${this.globalStore.currentSession().email}`);
  }

  private connectToStomp(url: string) {
    this.stompService.watch(url).subscribe({
      next: (data) => {
        this.handleMessage(data.body);
      },
    });
  }
}
